import { useEffect, useLayoutEffect, useState, type ReactNode } from 'react';

import { navigate } from './path-router';
import { NATIVE_USER_NAV } from './native-booking-constants';
import type { NativeMe } from './native-booking-api';

function navActive(itemPath: string, path: string): boolean {
  return path === itemPath || (itemPath !== '/account' && path.startsWith(`${itemPath}/`));
}

export function NativeCabinetShell(props: {
  readonly path: string;
  readonly me: NativeMe | null;
  readonly children: ReactNode;
  readonly onLogout: () => void;
}): React.ReactElement {
  useLayoutEffect(() => {
    document.body.classList.add('native-cabinet-app');
    return () => {
      document.body.classList.remove('native-cabinet-app');
    };
  }, []);

  const showNav = props.me !== null && props.path !== '/account';

  return (
    <div className="native-cabinet">
      <header className="native-header">
        <div className="native-head-inner">
          <div className="native-logo">
            <span className="native-logo-mark" aria-hidden="true">
              ✓
            </span>
            <div>
              <strong>CheckTS</strong>
              <small>Проверка техники</small>
            </div>
          </div>
          {showNav ? (
            <nav className="native-nav" aria-label="Личный кабинет">
              {NATIVE_USER_NAV.filter((item) => item.path !== '/account').map((item) => (
                <button
                  key={item.path}
                  type="button"
                  className={navActive(item.path, props.path) ? 'active' : undefined}
                  aria-current={navActive(item.path, props.path) ? 'page' : undefined}
                  onClick={() => {
                    navigate(item.path);
                  }}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          ) : null}
          <div className="native-head-user">
            {props.me !== null ? (
              <>
                <span className="native-avatar" aria-hidden="true">
                  {props.me.email.slice(0, 1).toUpperCase()}
                </span>
                <span className="native-user-email">
                  {props.me.email}
                  <button
                    type="button"
                    className="native-account-link"
                    onClick={() => {
                      navigate('/account');
                    }}
                  >
                    Пользователь
                  </button>
                </span>
                <button type="button" className="native-exit" onClick={props.onLogout}>
                  Выйти
                </button>
              </>
            ) : (
              <button
                type="button"
                className="native-exit"
                onClick={() => {
                  navigate('/account');
                }}
              >
                Войти
              </button>
            )}
          </div>
        </div>
      </header>
      <div className="native-container">{props.children}</div>
    </div>
  );
}

export function useHoldTicker(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) {
      return;
    }
    const id = window.setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => {
      window.clearInterval(id);
    };
  }, [active]);
  return now;
}
